//  document.addEventListener('DOMContentLoaded', function() {
//     $('.values-slider').slick({
//       dots: true,
//       arrows: false,
//       infinite: true,
//       speed: 600,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       adaptiveHeight: true,
//       autoplay: false,
//       autoplaySpeed: 4000
//     });
//   });






// Stories Section Js 
// document.addEventListener("DOMContentLoaded", function() {
//   $('.stories-slider').slick({
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     dots: true,
//     arrows: false,
//     infinite: true,
//     autoplay: false,
//     responsive: [
//       { breakpoint: 1024, settings: { slidesToShow: 2 } },
//       { breakpoint: 768, settings: { slidesToShow: 1 } }
//     ]
//   });
// });



// CUSTOM COLLECTION SWIPER SLIDER JS START HERE
document.addEventListener('DOMContentLoaded', function() {
  const section = document.getElementById('scroll-slider-section');
  const swiperEl = section.querySelector('.scroll-swiper');

  const scrollSwiper = new Swiper(swiperEl, {
    slidesPerView: 'auto',
    centeredSlides: false,
    loop: false,
    speed: 700,
    mousewheel: false,
    keyboard: { enabled: true },
    navigation: { nextEl: '.scroll-next-btn', prevEl: '.scroll-prev-btn' },
  });
// CUSTOM COLLECTION SWIPER SLIDER JS END HERE

  // TESTIMONIALS SLIDER JS
//   document.addEventListener("DOMContentLoaded", function() {
//   new Swiper(".values-slider.swiper", {
//     slidesPerView: 1,       
//     spaceBetween: 0,
//     loop: true,
//     pagination: {
//       el: ".swiper-pagination",
//       clickable: true,       
//     }
//   });
// });
// TESTIMONIALS SLIDER JS



  // let isActive = false;
  // let isScrolling = false;
  // let isMouseInside = false;

  // section.addEventListener('mouseenter', () => isMouseInside = true);
  // section.addEventListener('mouseleave', () => isMouseInside = false);

  // const observer = new IntersectionObserver((entries) => {
  //   entries.forEach((entry) => isActive = entry.isIntersecting);
  // }, { threshold: 0.3 });
  // observer.observe(section);

  // window.addEventListener('wheel', (e) => {
  //   if (!isActive || !isMouseInside) return;

    
  //   const hasMultipleSlides = scrollSwiper.slides.length > 1;
  //   if (!hasMultipleSlides) return; 

  //   const delta = e.deltaY;
  //   const atStart = scrollSwiper.isBeginning;
  //   const atEnd = scrollSwiper.isEnd;

  //   if (isScrolling) { e.preventDefault(); return; }

  //   if (!atEnd && delta > 0) {
  //     e.preventDefault();
  //     scrollSwiper.slideNext();
  //     isScrolling = true;
  //   } else if (!atStart && delta < 0) {
  //     e.preventDefault();
  //     scrollSwiper.slidePrev();
  //     isScrolling = true;
  //   }

  //   setTimeout(() => { isScrolling = false; }, 800);
  // }, { passive: false });
});
// CUSTOM COLLECTION SWIPER SLIDER JS END HERE

let priceDelayDone = false;

/* Start global timer once */
setTimeout(function () {
  priceDelayDone = true;
  document.querySelectorAll(".price").forEach(function (price) {
    price.classList.add("show-price");
  });
}, 4000);

/* Function to handle prices */
function handlePrices(root = document) {
  root.querySelectorAll(".price").forEach(function (price) {
    if (priceDelayDone) {
      price.classList.add("show-price");
    }
  });
}

/* Observe dynamically added elements */
const observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      if (node.nodeType === 1 && node.querySelectorAll) {
        handlePrices(node);
      }
    });
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

/* 🔥 FIX: Listen for variant change */
document.addEventListener("change", function (e) {
  if (e.target.matches('select[name="id"], input[name="id"]')) {
    setTimeout(function () {
      handlePrices(document);
    }, 100); // small delay to let Shopify update DOM
  }
});

/* 🔥 EXTRA: For themes using custom events */
document.addEventListener("variant:change", function () {
  setTimeout(function () {
    handlePrices(document);
  }, 100);
});


